/* VALIDATORS */
import {isValidPhoneNumber} from 'libphonenumber-js';
import {isValid as isValidEmail} from 'mailchecker';
import * as IBAN from 'iban';
import BIC from 'bic';

/* MIXINS */
import pwdRulesMixin from '@mixins/pwdRulesMixin';

export const roomValidator = (value) => {
  return value.zoneId !== undefined;
};

export const mustBeCool = (value) => {
  return value !== null;
};

export default {
  mixins: [pwdRulesMixin],
  methods: {
    phoneValidator(value) {
      return !value || isValidPhoneNumber(value);
    },

    emailValidator(value) {
      return !value || isValidEmail(value);
    },

    /*
     * Regex de Yousign pour valider un nom / prénom de signataire
     */
    yousignValidator(value) {
      return (
        !value ||
        /^(?!\s)[0-9A-Za-zĄÀÁÂÃÄÅÇĆÈÉÊËĘÌÍÎÏŁÑŃÒÓÔÕÖŚÙÚÛÜÝŹŻąàáâãäåæçćèéêëęìíîïłñńòóôõöśùúûüýÿźżßĀāĂăĈĉĊċČčĎďĐđĒēĔĕĖėĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŽžſøØÆȘșȚț`'()\- ]+(?<!\s)$/.test(
          value,
        )
      );
    },
    pwdValidator(value) {
      return !value || this.isValidPwd(value);
    },

    /* INFORMATIONS BANCAIRES */
    ibanValidator(value) {
      return !value || IBAN.isValid(value);
    },
    bicValidator(value) {
      return !value || BIC.isValid(value);
    },
  },
};
